import React from 'react';
import colors from 'theme/colors';
/* eslint-disable max-len */

const CheckIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0,0,256,256"
    width="24px"
    height="24px"
    fillRule="nonzero"
  >
    <g
      fillRule="nonzero"
      strokeWidth="1"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit="10"
      strokeDasharray=""
      strokeDashoffset="0"
      fontFamily="none"
      fontWeight="none"
      fontSize="none"
      textAnchor="none"
    >
      <g transform="scale(10.66667,10.66667)">
        <path d="M19.98047,5.99023c-0.2598,0.00774 -0.50638,0.11632 -0.6875,0.30273l-10.29297,10.29297l-3.29297,-3.29297c-0.25082,-0.26124 -0.62327,-0.36647 -0.97371,-0.27511c-0.35044,0.09136 -0.62411,0.36503 -0.71547,0.71547c-0.09136,0.35044 0.01388,0.72289 0.27511,0.97371l4,4c0.39053,0.39037 1.02353,0.39037 1.41406,0l11,-11c0.29576,-0.28749 0.38469,-0.72707 0.22393,-1.10691c-0.16075,-0.37985 -0.53821,-0.62204 -0.9505,-0.60988z" />
      </g>
    </g>
  </svg>
);

const BellIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3456 18.9996C13.2088 19.2353 13.0126 19.431 12.7764 19.567C12.5403 19.703 12.2725 19.7746 12 19.7746C11.7275 19.7746 11.4598 19.703 11.2236 19.567C10.9875 19.431 10.7912 19.2353 10.6545 18.9996M16.6667 8.88847C16.6667 7.65079 16.175 6.46381 15.2998 5.58864C14.4247 4.71347 13.2377 4.2218 12 4.2218C10.7623 4.2218 9.57534 4.71347 8.70017 5.58864C7.825 6.46381 7.33333 7.65079 7.33333 8.88847C7.33333 14.3329 5 15.8885 5 15.8885H19C19 15.8885 16.6667 14.3329 16.6667 8.88847Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SettingsIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1708 4.23743H11.8292C11.4175 4.23743 11.0226 4.401 10.7314 4.69215C10.4403 4.9833 10.2767 5.3782 10.2767 5.78995V5.92968C10.2764 6.20193 10.2046 6.46933 10.0683 6.70504C9.93206 6.94075 9.73622 7.13648 9.50044 7.27261L9.16665 7.46668C8.93063 7.60294 8.66291 7.67467 8.39038 7.67467C8.11786 7.67467 7.85014 7.60294 7.61412 7.46668L7.49768 7.40457C7.14143 7.19907 6.71819 7.14332 6.32087 7.24956C5.92355 7.3558 5.58463 7.61536 5.37849 7.97125L5.20771 8.26622C5.00221 8.62248 4.94646 9.04572 5.0527 9.44304C5.15894 9.84035 5.41849 10.1793 5.77438 10.3854L5.89082 10.463C6.12547 10.5985 6.32058 10.793 6.45676 11.0273C6.59294 11.2615 6.66545 11.5273 6.66708 11.7982V12.1941C6.66817 12.4677 6.59695 12.7367 6.46063 12.9739C6.32432 13.2111 6.12774 13.408 5.89082 13.5448L5.77438 13.6147C5.41849 13.8208 5.15894 14.1597 5.0527 14.5571C4.94646 14.9544 5.00221 15.3776 5.20771 15.7339L5.37849 16.0288C5.58463 16.3847 5.92355 16.6443 6.32087 16.7505C6.71819 16.8568 7.14143 16.801 7.49768 16.5955L7.61412 16.5334C7.85014 16.3971 8.11786 16.3254 8.39038 16.3254C8.66291 16.3254 8.93063 16.3971 9.16665 16.5334L9.50044 16.7275C9.73622 16.8636 9.93206 17.0593 10.0683 17.2951C10.2046 17.5308 10.2764 17.7982 10.2767 18.0704V18.2101C10.2767 18.6219 10.4403 19.0168 10.7314 19.3079C11.0226 19.5991 11.4175 19.7627 11.8292 19.7627H12.1708C12.5825 19.7627 12.9774 19.5991 13.2686 19.3079C13.5597 19.0168 13.7233 18.6219 13.7233 18.2101V18.0704C13.7236 17.7982 13.7955 17.5308 13.9317 17.2951C14.0679 17.0593 14.2638 16.8636 14.4996 16.7275L14.8334 16.5334C15.0694 16.3971 15.3371 16.3254 15.6096 16.3254C15.8821 16.3254 16.1499 16.3971 16.3859 16.5334L16.5023 16.5955C16.8586 16.801 17.2818 16.8568 17.6791 16.7505C18.0764 16.6443 18.4154 16.3847 18.6215 16.0288L18.7923 15.7261C18.9978 15.3698 19.0535 14.9466 18.9473 14.5493C18.8411 14.152 18.5815 13.813 18.2256 13.6069L18.1092 13.5448C17.8723 13.408 17.6757 13.2111 17.5394 12.9739C17.4031 12.7367 17.3318 12.4677 17.3329 12.1941V11.806C17.3318 11.5324 17.4031 11.2634 17.5394 11.0262C17.6757 10.789 17.8723 10.5921 18.1092 10.4553L18.2256 10.3854C18.5815 10.1793 18.8411 9.84035 18.9473 9.44304C19.0535 9.04572 18.9978 8.62248 18.7923 8.26622L18.6215 7.97125C18.4154 7.61536 18.0764 7.3558 17.6791 7.24956C17.2818 7.14332 16.8586 7.19907 16.5023 7.40457L16.3859 7.46668C16.1499 7.60294 15.8821 7.67467 15.6096 7.67467C15.3371 7.67467 15.0694 7.60294 14.8334 7.46668L14.4996 7.27261C14.2638 7.13648 14.0679 6.94075 13.9317 6.70504C13.7955 6.46933 13.7236 6.20193 13.7233 5.92968V5.78995C13.7233 5.3782 13.5597 4.9833 13.2686 4.69215C12.9774 4.401 12.5825 4.23743 12.1708 4.23743Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14.3288C13.2862 14.3288 14.3288 13.2862 14.3288 12C14.3288 10.7139 13.2862 9.67126 12 9.67126C10.7138 9.67126 9.67122 10.7139 9.67122 12C9.67122 13.2862 10.7138 14.3288 12 14.3288Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.1665 3.33317C5.94484 3.33317 3.33317 5.94484 3.33317 9.1665C3.33317 12.3882 5.94484 14.9998 9.1665 14.9998C12.3882 14.9998 14.9998 12.3882 14.9998 9.1665C14.9998 5.94484 12.3882 3.33317 9.1665 3.33317ZM1.6665 9.1665C1.6665 5.02437 5.02437 1.6665 9.1665 1.6665C13.3086 1.6665 16.6665 5.02437 16.6665 9.1665C16.6665 13.3086 13.3086 16.6665 9.1665 16.6665C5.02437 16.6665 1.6665 13.3086 1.6665 9.1665Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2856 13.2856C13.611 12.9601 14.1387 12.9601 14.4641 13.2856L18.0891 16.9106C18.4145 17.236 18.4145 17.7637 18.0891 18.0891C17.7637 18.4145 17.236 18.4145 16.9106 18.0891L13.2856 14.4641C12.9601 14.1387 12.9601 13.611 13.2856 13.2856Z"
    />
  </svg>
);

const UploadIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.00009 14.8988C3.25714 14.1397 2.69666 13.2215 2.36113 12.2137C2.0256 11.2059 1.9238 10.135 2.06346 9.08208C2.20311 8.02913 2.58055 7.02178 3.16719 6.13631C3.75383 5.25085 4.53428 4.51049 5.44943 3.97133C6.36458 3.43216 7.39042 3.10833 8.44926 3.02435C9.5081 2.94038 10.5722 3.09846 11.5609 3.48664C12.5496 3.87481 13.4369 4.48289 14.1558 5.26481C14.8747 6.04674 15.4062 6.98201 15.7101 7.99978H17.5001C18.4656 7.99967 19.4056 8.3101 20.1811 8.88522C20.9566 9.46033 21.5266 10.2696 21.8069 11.1936C22.0871 12.1175 22.0628 13.1071 21.7374 14.0162C21.4121 14.9252 20.803 15.7055 20.0001 16.2418"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12V21"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16L12 12L8 16"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AppImgIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H12"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 5H22"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 2V8"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.89543 7 7 7.89543 7 9C7 10.1046 7.89543 11 9 11Z"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M21 15.0002L17.914 11.9142C17.5389 11.5392 17.0303 11.3286 16.5 11.3286C15.9697 11.3286 15.4611 11.5392 15.086 11.9142L6 21.0002"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PlusIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00024 3.3335V12.6668M3.33325 8.00018H12.6666"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SortingChevronIcon = (
  <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.62322 17.8371C7.83147 18.0541 8.16966 18.0541 8.37791 17.8371L10.5104 15.6158C10.6636 15.4561 10.7086 15.2184 10.6253 15.0101C10.542 14.8019 10.3488 14.6665 10.1322 14.6665L5.86729 14.6682C5.65238 14.6682 5.45746 14.8036 5.37416 15.0119C5.29086 15.2201 5.33751 15.4579 5.48911 15.6175L7.62156 17.8389L7.62322 17.8371Z"
      fill="#6C6C6C"
    />
    <path
      d="M8.37677 6.16286C8.16853 5.94593 7.83034 5.94593 7.62209 6.16286L5.48965 8.38421C5.33638 8.54387 5.2914 8.78163 5.37469 8.98988C5.45799 9.19813 5.65125 9.3335 5.86782 9.3335L10.1327 9.33176C10.3476 9.33176 10.5425 9.1964 10.6258 8.98814C10.7091 8.77989 10.6625 8.54214 10.5109 8.38248L8.37844 6.16112L8.37677 6.16286Z"
      fill="#6C6C6C"
    />
  </svg>
);

const ChevronDownIcon = (
  <svg width="8" height="6" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 1.5L5 5.5L9 1.5"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MicIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M9.99997 2.85742C9.43166 2.85742 8.88664 3.08318 8.48479 3.48503C8.08294 3.88688 7.85718 4.43191 7.85718 5.00021V10.0001C7.85718 10.5684 8.08294 11.1134 8.48479 11.5152C8.88664 11.9171 9.43166 12.1428 9.99997 12.1428C10.5683 12.1428 11.1133 11.9171 11.5151 11.5152C11.917 11.1134 12.1428 10.5684 12.1428 10.0001V5.00021C12.1428 4.43191 11.917 3.88688 11.5151 3.48503C11.1133 3.08318 10.5683 2.85742 9.99997 2.85742Z"
      strokeWidth="1.42853"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M14.9997 8.57129V9.99982C14.9997 11.3259 14.4729 12.5976 13.5353 13.5352C12.5976 14.4729 11.3259 14.9997 9.99984 14.9997C8.6738 14.9997 7.40207 14.4729 6.46442 13.5352C5.52677 12.5976 5 11.3259 5 9.99982V8.57129"
      strokeWidth="1.42853"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 15V17.1428" strokeWidth="1.42853" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SmilePlusIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M16.9998 9.29305V9.99305C16.9927 11.4059 16.5583 12.7835 15.7536 13.9448C14.949 15.1061 13.8117 15.9967 12.4914 16.4995C11.1711 17.0024 9.72952 17.094 8.35619 16.7622C6.98286 16.4304 5.74207 15.6908 4.79694 14.6407C3.8518 13.5905 3.24656 12.279 3.06078 10.8784C2.87501 9.47784 3.11739 8.05384 3.75607 6.7936C4.39475 5.53337 5.39983 4.4959 6.63917 3.81757C7.87852 3.13925 9.29412 2.85183 10.6999 2.99309"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M7.19995 11.3936C7.19995 11.3936 8.24994 12.7935 9.99993 12.7935C11.7499 12.7935 12.7999 11.3936 12.7999 11.3936"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.8999 7.89355H7.90725"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1001 7.89355H12.1074"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.8 5.09375H17" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M14.8999 2.99316V7.19314"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AttachIcon = (
  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M16.0001 8.293L9.1613 15.1318C8.32349 15.9696 7.18718 16.4403 6.00235 16.4403C4.81751 16.4403 3.6812 15.9696 2.84339 15.1318C2.00559 14.294 1.53491 13.1577 1.53491 11.9729C1.53491 10.788 2.00559 9.65172 2.84339 8.81392L9.22083 2.43648C9.77937 1.87695 10.5373 1.56222 11.3279 1.56152C12.1185 1.56083 12.877 1.87422 13.4365 2.43276C13.996 2.99129 14.3107 3.74922 14.3114 4.53981C14.3121 5.3304 13.9987 6.08889 13.4402 6.64841L7.04789 13.0259C6.76862 13.3051 6.38985 13.462 5.9949 13.462C5.59996 13.462 5.22119 13.3051 4.94192 13.0259C4.66265 12.7466 4.50576 12.3678 4.50576 11.9729C4.50576 11.5779 4.66265 11.1992 4.94192 10.9199L11.2598 4.60942"
      strokeWidth="1.48832"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FlagIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M2.66602 10.0002C2.66602 10.0002 3.33268 9.3335 5.33268 9.3335C7.33268 9.3335 8.66602 10.6668 10.666 10.6668C12.666 10.6668 13.3327 10.0002 13.3327 10.0002V2.00016C13.3327 2.00016 12.666 2.66683 10.666 2.66683C8.66602 2.66683 7.33268 1.3335 5.33268 1.3335C3.33268 1.3335 2.66602 2.00016 2.66602 2.00016V10.0002Z"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66602 14.6667V10"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DotsIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PencilIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M11.6001 2L14.0001 4.40002M5.30003 13.1001L12.2001 6.20004L9.80007 3.80002L2.90001 10.7001L2 14.0001L5.30003 13.1001Z"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BinIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M2 3.99969H14M12.6654 3.99969V13.333C12.6654 13.9997 11.9987 14.6664 11.332 14.6664H4.66536C3.9987 14.6664 3.33203 13.9997 3.33203 13.333V3.99969M5.33203 3.99967V2.66634C5.33203 1.99967 5.9987 1.33301 6.66536 1.33301H9.33203C9.9987 1.33301 10.6654 1.99967 10.6654 2.66634V3.99967"
      stroke="#E33535"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MailIcon = (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M30 6H6C4.34315 6 3 7.34315 3 9V27C3 28.6569 4.34315 30 6 30H30C31.6569 30 33 28.6569 33 27V9C33 7.34315 31.6569 6 30 6Z"
      stroke="white"
      strokeWidth="2.625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M33 10.5L19.545 19.05C19.0819 19.3401 18.5465 19.494 18 19.494C17.4535 19.494 16.9181 19.3401 16.455 19.05L3 10.5"
      stroke="white"
      strokeWidth="2.625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReferenceDocumentIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#1F3D61" />
    <path
      /*  */
      d="M18.0833 7.66699H11C10.558 7.66699 10.134 7.84259 9.82148 8.15515C9.50892 8.46771 9.33333 8.89163 9.33333 9.33366V22.667C9.33333 23.109 9.50892 23.5329 9.82148 23.8455C10.134 24.1581 10.558 24.3337 11 24.3337H21C21.442 24.3337 21.8659 24.1581 22.1785 23.8455C22.4911 23.5329 22.6667 23.109 22.6667 22.667V12.2503L18.0833 7.66699Z"
      stroke="#1479F0"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6667 7.66699V12.667H22.6667"
      stroke="#1479F0"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3333 16.833H12.6667"
      stroke="#1479F0"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3333 20.167H12.6667"
      stroke="#1479F0"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3333 13.5H12.6667"
      stroke="#1479F0"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReferenceImageIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#372F4F" />
    <path
      /*  */
      d="M21.8333 8.5H10.1667C9.24619 8.5 8.5 9.24619 8.5 10.1667V21.8333C8.5 22.7538 9.24619 23.5 10.1667 23.5H21.8333C22.7538 23.5 23.5 22.7538 23.5 21.8333V10.1667C23.5 9.24619 22.7538 8.5 21.8333 8.5Z"
      stroke="#7C66BD"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M13.5 15.1663C14.4205 15.1663 15.1667 14.4201 15.1667 13.4997C15.1667 12.5792 14.4205 11.833 13.5 11.833C12.5795 11.833 11.8333 12.5792 11.8333 13.4997C11.8333 14.4201 12.5795 15.1663 13.5 15.1663Z"
      stroke="#7C66BD"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M23.5 18.5001L20.9283 15.9284C20.6158 15.616 20.1919 15.4404 19.75 15.4404C19.3081 15.4404 18.8842 15.616 18.5717 15.9284L11 23.5001"
      stroke="#7C66BD"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReferenceLinkIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#40476C" />
    <g clipPath="url(#clip0_2173_6591)">
      <path
        /*  */
        d="M14.3333 16.833C14.6912 17.3114 15.1478 17.7073 15.6721 17.9938C16.1964 18.2802 16.7763 18.4506 17.3722 18.4933C17.9682 18.5359 18.5663 18.45 19.1261 18.2411C19.6859 18.0323 20.1943 17.7055 20.6167 17.283L23.1167 14.783C23.8757 13.9971 24.2956 12.9446 24.2861 11.8521C24.2766 10.7597 23.8384 9.7146 23.0659 8.94207C22.2934 8.16953 21.2483 7.73133 20.1558 7.72184C19.0633 7.71234 18.0108 8.13232 17.225 8.89131L15.7917 10.3163"
        stroke="#6B83FF"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        /*  */
        d="M17.6668 15.167C17.309 14.6886 16.8524 14.2927 16.328 14.0062C15.8037 13.7198 15.2239 13.5494 14.628 13.5067C14.032 13.4641 13.4338 13.55 12.874 13.7589C12.3142 13.9677 11.8059 14.2945 11.3835 14.717L8.8835 17.217C8.12451 18.0029 7.70453 19.0554 7.71402 20.1479C7.72352 21.2403 8.16172 22.2854 8.93426 23.0579C9.70679 23.8305 10.7518 24.2687 11.8443 24.2782C12.9368 24.2877 13.9893 23.8677 14.7752 23.1087L16.2002 21.6837"
        stroke="#6B83FF"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2173_6591">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);

const ReferenceGoogleDriveLinkIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#404040" />
    <g clipPath="url(#clip0_2_26)">
      <path
        d="M7.51203 22.3069L8.39404 23.8296C8.57732 24.1502 8.84078 24.402 9.15006 24.5852L12.3001 19.1356H6C6 19.4905 6.09164 19.8454 6.27491 20.166L7.51203 22.3069Z"
        fill="#0066DA"
      />
      <path
        d="M16 12.7244L12.8499 7.27478C12.5407 7.45796 12.2772 7.70983 12.0939 8.0304L6.27491 18.1053C6.09501 18.4189 6.00024 18.7741 6 19.1357H12.3001L16 12.7244Z"
        fill="#00AC47"
      />
      <path
        d="M22.8499 24.5852C23.1592 24.402 23.4227 24.1502 23.606 23.8296L23.9725 23.1999L25.7251 20.166C25.9084 19.8454 26 19.4905 26 19.1356H19.6994L21.0401 21.7688L22.8499 24.5852Z"
        fill="#EA4335"
      />
      <path
        d="M16 12.7244L19.1501 7.27477C18.8408 7.09159 18.4857 7 18.1191 7H13.8809C13.5143 7 13.1592 7.10304 12.8499 7.27477L16 12.7244Z"
        fill="#00832D"
      />
      <path
        d="M19.6999 19.1356H12.3001L9.15005 24.5852C9.45933 24.7684 9.81443 24.86 10.181 24.86H21.819C22.1856 24.86 22.5407 24.7569 22.8499 24.5852L19.6999 19.1356Z"
        fill="#2684FC"
      />
      <path
        d="M22.8156 13.0678L19.9061 8.0304C19.7228 7.70983 19.4593 7.45796 19.1501 7.27478L16 12.7244L19.6999 19.1357H25.9885C25.9885 18.7807 25.8969 18.4258 25.7136 18.1053L22.8156 13.0678Z"
        fill="#FFBA00"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_26">
        <rect width="20" height="17.86" fill="white" transform="translate(6 7)" />
      </clipPath>
    </defs>
  </svg>
);

const ReferenceSlackLinkIcon = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#404040" />
    <path
      d="M9.99186 19.0065C9.99186 20.1051 9.09446 21.0025 7.99593 21.0025C6.89739 21.0025 6 20.1051 6 19.0065C6 17.908 6.89739 17.0106 7.99593 17.0106H9.99186V19.0065Z"
      fill="#E01E5A"
    />
    <path
      d="M10.9976 19.0065C10.9976 17.908 11.895 17.0106 12.9935 17.0106C14.092 17.0106 14.9894 17.908 14.9894 19.0065V24.0041C14.9894 25.1026 14.092 26 12.9935 26C11.895 26 10.9976 25.1026 10.9976 24.0041V19.0065Z"
      fill="#E01E5A"
    />
    <path
      d="M12.9935 10.9919C11.895 10.9919 10.9976 10.0945 10.9976 8.99593C10.9976 7.89739 11.895 7 12.9935 7C14.092 7 14.9894 7.89739 14.9894 8.99593V10.9919H12.9935Z"
      fill="#36C5F0"
    />
    <path
      d="M12.9935 11.9976C14.092 11.9976 14.9894 12.895 14.9894 13.9935C14.9894 15.092 14.092 15.9894 12.9935 15.9894H7.99593C6.89739 15.9894 6 15.092 6 13.9935C6 12.895 6.89739 11.9976 7.99593 11.9976H12.9935Z"
      fill="#36C5F0"
    />
    <path
      d="M21.0082 13.9935C21.0082 12.895 21.9056 11.9976 23.0041 11.9976C24.1026 11.9976 25 12.895 25 13.9935C25 15.092 24.1026 15.9894 23.0041 15.9894H21.0082V13.9935Z"
      fill="#2EB67D"
    />
    <path
      d="M20.0025 13.9935C20.0025 15.092 19.1051 15.9894 18.0065 15.9894C16.908 15.9894 16.0106 15.092 16.0106 13.9935V8.99593C16.0106 7.89739 16.908 7 18.0065 7C19.1051 7 20.0025 7.89739 20.0025 8.99593V13.9935Z"
      fill="#2EB67D"
    />
    <path
      d="M18.0065 22.0082C19.1051 22.0082 20.0025 22.9056 20.0025 24.0041C20.0025 25.1026 19.1051 26 18.0065 26C16.908 26 16.0106 25.1026 16.0106 24.0041V22.0082H18.0065Z"
      fill="#ECB22E"
    />
    <path
      d="M18.0065 21.0025C16.908 21.0025 16.0106 20.1051 16.0106 19.0065C16.0106 17.908 16.908 17.0106 18.0065 17.0106H23.0041C24.1026 17.0106 25 17.908 25 19.0065C25 20.1051 24.1026 21.0025 23.0041 21.0025H18.0065Z"
      fill="#ECB22E"
    />
  </svg>
);

const CalendarIcon = (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M15.8333 3.83301H4.16667C3.24619 3.83301 2.5 4.5792 2.5 5.49967V17.1663C2.5 18.0868 3.24619 18.833 4.16667 18.833H15.8333C16.7538 18.833 17.5 18.0868 17.5 17.1663V5.49967C17.5 4.5792 16.7538 3.83301 15.8333 3.83301Z"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 2.16699V5.50033"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66669 2.16699V5.50033"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 8.83301H17.5"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66669 12.167H6.67559"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.167H10.0089"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 12.167H13.3422"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66669 15.5H6.67559"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 15.5H10.0089"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 15.5H13.3422"
      stroke="#9A9A9A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UserIcon = (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M15.8333 18V16.3333C15.8333 15.4493 15.4821 14.6014 14.857 13.9763C14.2319 13.3512 13.3841 13 12.5 13H7.5C6.61595 13 5.7681 13.3512 5.14298 13.9763C4.51786 14.6014 4.16667 15.4493 4.16667 16.3333V18"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M10 9.66667C11.841 9.66667 13.3333 8.17428 13.3333 6.33333C13.3333 4.49238 11.841 3 10 3C8.15905 3 6.66667 4.49238 6.66667 6.33333C6.66667 8.17428 8.15905 9.66667 10 9.66667Z"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExternalLinkIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M17.3333 12.8892V18.2225C17.3333 18.694 17.146 19.1462 16.8126 19.4796C16.4792 19.813 16.0271 20.0003 15.5556 20.0003H5.77778C5.30628 20.0003 4.8541 19.813 4.5207 19.4796C4.1873 19.1462 4 18.694 4 18.2225V8.44477C4 7.97327 4.1873 7.52109 4.5207 7.18769C4.8541 6.85429 5.30628 6.66699 5.77778 6.66699H11.1111"
      stroke="inherit"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 4H20V9.33333"
      stroke="inherit"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2222 13.7778L20 4"
      stroke="inherit"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DownloadIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 10L12 15L17 10"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15V3"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RadioButtonChevron = (
  <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 1L5.375 10L1 5.90909"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LinkIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2294_10174)">
      <path
        /*  */
        d="M10.3333 12.8335C10.6912 13.3119 11.1478 13.7078 11.6721 13.9943C12.1965 14.2807 12.7763 14.4511 13.3722 14.4937C13.9682 14.5364 14.5663 14.4504 15.1261 14.2416C15.6859 14.0328 16.1943 13.706 16.6167 13.2835L19.1167 10.7835C19.8757 9.99762 20.2956 8.94512 20.2862 7.85263C20.2767 6.76014 19.8385 5.71509 19.0659 4.94256C18.2934 4.17002 17.2483 3.73182 16.1558 3.72233C15.0634 3.71283 14.0109 4.13281 13.225 4.8918L11.7917 6.3168"
        stroke="#DCDCDC"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        /*  */
        d="M13.6668 11.1665C13.309 10.6881 12.8524 10.2922 12.328 10.0057C11.8037 9.71928 11.2239 9.54893 10.628 9.50625C10.032 9.46357 9.43384 9.54956 8.87405 9.75838C8.31425 9.9672 7.8059 10.294 7.3835 10.7165L4.8835 13.2165C4.12451 14.0024 3.70453 15.0549 3.71402 16.1474C3.72352 17.2399 4.16172 18.2849 4.93426 19.0574C5.70679 19.83 6.75184 20.2682 7.84433 20.2777C8.93681 20.2872 9.98932 19.8672 10.7752 19.1082L12.2002 17.6832"
        stroke="#DCDCDC"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2294_10174">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

const CloseIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9L9 15"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9L15 15"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UploadCloudIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M3.99997 14.899C3.25701 14.1399 2.69654 13.2217 2.36101 12.214C2.02547 11.2062 1.92368 10.1353 2.06333 9.08232C2.20299 8.02938 2.58043 7.02202 3.16707 6.13655C3.75371 5.25109 4.53416 4.51074 5.44931 3.97157C6.36445 3.43241 7.3903 3.10857 8.44914 3.0246C9.50798 2.94062 10.572 3.09871 11.5607 3.48688C12.5494 3.87505 13.4368 4.48313 14.1557 5.26506C14.8746 6.04698 15.4061 6.98225 15.71 8.00002H17.5C18.4655 7.99991 19.4054 8.31034 20.181 8.88546C20.9565 9.46058 21.5265 10.2699 21.8067 11.1938C22.087 12.1178 22.0627 13.1074 21.7373 14.0164C21.412 14.9254 20.8028 15.7057 20 16.242"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12V21"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16L12 12L8 16"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SendIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth="2"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <line x1="10" y1="14" x2="21" y2="3" />
    <path d="M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5" />
  </svg>
);

const InfoIcon = (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M9.99984 18.8327C14.6022 18.8327 18.3332 15.1017 18.3332 10.4993C18.3332 5.89698 14.6022 2.16602 9.99984 2.16602C5.39746 2.16602 1.6665 5.89698 1.6665 10.4993C1.6665 15.1017 5.39746 18.8327 9.99984 18.8327Z"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 13.8333V10.5" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M10 7.16602H10.0083"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LikeIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.42383 8.57373V17.1315"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M12.1293 5.63566L11.4162 8.57382H15.5738C15.7952 8.57382 16.0136 8.62537 16.2116 8.7244C16.4097 8.82342 16.582 8.9672 16.7148 9.14434C16.8477 9.32148 16.9375 9.52712 16.9771 9.74497C17.0167 9.96282 17.005 10.1869 16.943 10.3995L15.2814 16.1046C15.195 16.4009 15.0148 16.6611 14.7679 16.8463C14.5211 17.0315 14.2208 17.1316 13.9122 17.1316H4.28469C3.90641 17.1316 3.54363 16.9813 3.27615 16.7138C3.00867 16.4463 2.8584 16.0836 2.8584 15.7053V10.0001C2.8584 9.62184 3.00867 9.25905 3.27615 8.99157C3.54363 8.72409 3.90641 8.57382 4.28469 8.57382H6.25297C6.51832 8.57368 6.77837 8.49952 7.00388 8.35968C7.22939 8.21984 7.41142 8.01986 7.5295 7.78223L9.98986 2.86865C10.3262 2.87282 10.6572 2.95292 10.9582 3.10299C11.2592 3.25305 11.5224 3.4692 11.7281 3.73527C11.9338 4.00134 12.0767 4.31046 12.1462 4.63954C12.2157 4.96861 12.2099 5.30913 12.1293 5.63566V5.63566Z"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LikeFilledIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.42383 8.57422V17.132"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M12.1293 5.63517L11.4162 8.57333H15.5738C15.7952 8.57333 16.0136 8.62489 16.2116 8.72391C16.4097 8.82293 16.582 8.96671 16.7148 9.14385C16.8477 9.32099 16.9375 9.52663 16.9771 9.74448C17.0167 9.96233 17.005 10.1864 16.943 10.399L15.2814 16.1042C15.195 16.4004 15.0148 16.6607 14.7679 16.8458C14.5211 17.031 14.2208 17.1311 13.9122 17.1311H4.28469C3.90641 17.1311 3.54363 16.9808 3.27615 16.7133C3.00867 16.4459 2.8584 16.0831 2.8584 15.7048V9.99962C2.8584 9.62135 3.00867 9.25856 3.27615 8.99108C3.54363 8.7236 3.90641 8.57333 4.28469 8.57333H6.25297C6.51832 8.57319 6.77837 8.49903 7.00388 8.35919C7.22939 8.21935 7.41142 8.01937 7.5295 7.78174L9.98986 2.86816C10.3262 2.87233 10.6572 2.95244 10.9582 3.1025C11.2592 3.25257 11.5224 3.46871 11.7281 3.73478C11.9338 4.00085 12.0767 4.30997 12.1462 4.63905C12.2157 4.96812 12.2099 5.30865 12.1293 5.63517Z"
      fill="#7C87B5"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReplyIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.50016 14.1663L3.3335 9.99967L7.50016 5.83301"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M16.6668 15V13.3333C16.6668 12.4493 16.3156 11.6014 15.6905 10.9763C15.0654 10.3512 14.2176 10 13.3335 10H3.3335"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BranchIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 2.5V12.5"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M15 7.5C15.663 7.5 16.2989 7.23661 16.7678 6.76777C17.2366 6.29893 17.5 5.66304 17.5 5C17.5 4.33696 17.2366 3.70107 16.7678 3.23223C16.2989 2.76339 15.663 2.5 15 2.5C14.337 2.5 13.7011 2.76339 13.2322 3.23223C12.7634 3.70107 12.5 4.33696 12.5 5C12.5 5.66304 12.7634 6.29893 13.2322 6.76777C13.7011 7.23661 14.337 7.5 15 7.5Z"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M5 17.5C5.66304 17.5 6.29893 17.2366 6.76777 16.7678C7.23661 16.2989 7.5 15.663 7.5 15C7.5 14.337 7.23661 13.7011 6.76777 13.2322C6.29893 12.7634 5.66304 12.5 5 12.5C4.33696 12.5 3.70107 12.7634 3.23223 13.2322C2.76339 13.7011 2.5 14.337 2.5 15C2.5 15.663 2.76339 16.2989 3.23223 16.7678C3.70107 17.2366 4.33696 17.5 5 17.5V17.5Z"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 5C10.5109 5 8.60322 5.79018 7.1967 7.1967C5.79018 8.60322 5 10.5109 5 12.5"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 12.5V17.5"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 15H12.5"
      stroke="#7C87B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AddUserIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M16.7998 21V19C16.7998 17.9391 16.3784 16.9217 15.6282 16.1716C14.8781 15.4214 13.8607 15 12.7998 15H6.7998C5.73893 15 4.72152 15.4214 3.97137 16.1716C3.22123 16.9217 2.7998 17.9391 2.7998 19V21"
      stroke="#8B8B8E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.7998 11C12.0089 11 13.7998 9.20914 13.7998 7C13.7998 4.79086 12.0089 3 9.7998 3C7.59066 3 5.7998 4.79086 5.7998 7C5.7998 9.20914 7.59066 11 9.7998 11Z"
      stroke="#8B8B8E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.7998 11H16.7998"
      stroke="#8B8B8E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.0005 8.00261V14.0026"
      stroke="#8B8B8E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RemoveUserIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      /*  */
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      /*  */
      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M22 11H16" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const QuestionEventIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" fill="#895725" />
    <path
      /*  */
      d="M8.63037 9.34619C8.92755 8.50141 9.51411 7.78906 10.2862 7.33531C11.0582 6.88156 11.966 6.71569 12.8486 6.86709C13.7313 7.01849 14.5318 7.47737 15.1085 8.16247C15.6853 8.84757 16.0009 9.71468 15.9996 10.6102C15.9996 13.1382 12.2075 14.4023 12.2075 14.4023M12.4224 18.1886H12.4351"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" stroke="#432918" strokeWidth="1.2" />
  </svg>
);

const DecisionEventIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" fill="#D57232" />
    <path
      /*  */
      d="M12.4995 14.9004C11.3949 14.9004 10.4995 15.7958 10.4995 16.9004C10.4995 18.005 11.3949 18.9004 12.4995 18.9004C13.6041 18.9004 14.4995 18.005 14.4995 16.9004C14.4995 15.7958 13.6041 14.9004 12.4995 14.9004ZM12.4995 14.9004V12.9004M8.49951 10.9004C9.60408 10.9004 10.4995 10.005 10.4995 8.90039C10.4995 7.79582 9.60408 6.90039 8.49951 6.90039C7.39494 6.90039 6.49951 7.79582 6.49951 8.90039C6.49951 10.005 7.39494 10.9004 8.49951 10.9004ZM8.49951 10.9004V11.5671C8.49951 11.9207 8.63999 12.2598 8.89004 12.5099C9.14008 12.7599 9.47922 12.9004 9.83285 12.9004H15.1662C15.5198 12.9004 15.8589 12.7599 16.109 12.5099C16.359 12.2598 16.4995 11.9207 16.4995 11.5671V10.9004M16.4995 10.9004C17.6041 10.9004 18.4995 10.005 18.4995 8.90039C18.4995 7.79582 17.6041 6.90039 16.4995 6.90039C15.3949 6.90039 14.4995 7.79582 14.4995 8.90039C14.4995 10.005 15.3949 10.9004 16.4995 10.9004Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" stroke="#432918" strokeWidth="1.2" />
  </svg>
);

const InsightEventIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" fill="#6B83FF" />
    <g clipPath="url(#clip0_3238_18427)">
      <path
        /*  */
        d="M10.3999 16.0671H14.3999M11.0666 18.7337H13.7332M14.4599 13.4004C14.5799 12.7471 14.8932 12.2404 15.3999 11.7337C15.7218 11.4374 15.9773 11.0763 16.1497 10.6741C16.3221 10.272 16.4073 9.83786 16.3999 9.40039C16.3999 8.33952 15.9785 7.32211 15.2283 6.57196C14.4782 5.82182 13.4608 5.40039 12.3999 5.40039C11.339 5.40039 10.3216 5.82182 9.57148 6.57196C8.82133 7.32211 8.3999 8.33952 8.3999 9.40039C8.3999 10.0671 8.55324 10.8871 9.3999 11.7337C9.8826 12.1751 10.2119 12.759 10.3399 13.4004"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" stroke="#233861" strokeWidth="1.2" />
    <defs>
      <clipPath id="clip0_3238_18427">
        <rect width="16" height="16" fill="white" transform="translate(4.3999 4.40039)" />
      </clipPath>
    </defs>
  </svg>
);

const StoppedEventIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" fill="#B73131" />
    <path
      d="M11.0666 7.06738H8.3999V17.734H11.0666V7.06738Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3996 7.06738H13.7329V17.734H16.3996V7.06738Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" stroke="#4D2323" strokeWidth="1.2" />
  </svg>
);

const ActionEventIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" fill="#7C66BD" />
    <path
      d="M7.3999 7.40039L12.1132 18.7337L13.7866 13.8071L18.7332 12.1137L7.3999 7.40039Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" stroke="#372F4F" strokeWidth="1.2" />
  </svg>
);

const ResolutionEventIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" fill="#A1C380" />
    <path
      d="M16.9992 8L9.66585 15.3333L6.33252 12"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6665 10.667L14.6665 15.667L13.6665 14.667"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" stroke="#074F2D" strokeWidth="1.2" />
  </svg>
);

const EndEventIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" fill="#8B8B8E" />
    <path
      d="M10.7866 18.2137V6.78516L16.5009 9.6423L10.7866 12.4994"
      stroke="white"
      strokeWidth="1.28571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" stroke="#BDBDBD" strokeWidth="1.2" />
  </svg>
);

const FilterIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 4H3L10.2 12.4089V18.2222L13.8 20V12.4089L21 4Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExitIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2621_23506)">
      <path
        /* eslint-disable-next-line max-len */
        d="M10.5 6V4.5C10.5 4.10218 10.342 3.72064 10.0607 3.43934C9.77936 3.15804 9.39783 3 9 3H3.75C3.35218 3 2.97064 3.15804 2.68934 3.43934C2.40804 3.72064 2.25 4.10218 2.25 4.5V13.5C2.25 13.8978 2.40804 14.2794 2.68934 14.5607C2.97064 14.842 3.35218 15 3.75 15H9C9.39783 15 9.77936 14.842 10.0607 14.5607C10.342 14.2794 10.5 13.8978 10.5 13.5V12"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 9H15.75M15.75 9L13.5 6.75M15.75 9L13.5 11.25"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2621_23506">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const IssueEventIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-exclamation-circle"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    strokeWidth="2"
    stroke="white"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect stroke="none" x="1.1" y="1.1" width="22.8" height="22.8" rx="11.4" fill={colors.red2} />
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path stroke="white" d="M12 7v6" />
    <path stroke="white" d="M12 17v.01" />
  </svg>
);

const CheckCircle = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_867_8524)">
      <path
        /* eslint-disable-next-line max-len */
        d="M20.2327 11.2426V12C20.2317 13.7753 19.6568 15.5027 18.5939 16.9245C17.5309 18.3464 16.0368 19.3866 14.3344 19.89C12.6319 20.3933 10.8124 20.3329 9.14712 19.7176C7.48185 19.1024 6.06006 17.9654 5.09381 16.4761C4.12756 14.9868 3.66862 13.225 3.78542 11.4536C3.90223 9.68214 4.58853 7.99592 5.74198 6.64639C6.89542 5.29687 8.4542 4.35635 10.1858 3.96511C11.9175 3.57387 13.7292 3.75287 15.3508 4.47541"
        strokeWidth="1.64651"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4745 7.18018L12 13.6546L9.53027 11.1848"
        strokeWidth="1.64651"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const BrokenLink = (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3845_27788)">
      <path
        d="M7.5 11.0003C7.74441 11.2497 8.03614 11.4479 8.3581 11.5832C8.68005 11.7185 9.02577 11.7882 9.375 11.7882C9.72423 11.7882 10.0699 11.7185 10.3919 11.5832C10.7139 11.4479 11.0056 11.2497 11.25 11.0003L14.25 8.00028C14.7473 7.503 15.0267 6.82854 15.0267 6.12528C15.0267 5.42202 14.7473 4.74756 14.25 4.25028C13.7527 3.753 13.0783 3.47363 12.375 3.47363C11.6717 3.47363 10.9973 3.753 10.5 4.25028L10.125 4.62528"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5003 7.9998C10.2559 7.75035 9.96415 7.55218 9.64219 7.41689C9.32023 7.2816 8.97451 7.21191 8.62528 7.21191C8.27606 7.21191 7.93034 7.2816 7.60838 7.41689C7.28642 7.55218 6.99469 7.75035 6.75028 7.9998L3.75028 10.9998C3.253 11.4971 2.97363 12.1715 2.97363 12.8748C2.97363 13.5781 3.253 14.2525 3.75028 14.7498C4.24756 15.2471 4.92202 15.5264 5.62528 15.5264C6.32854 15.5264 7.003 15.2471 7.50028 14.7498L7.87528 14.3748"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.25V14.75"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 12.5H15.75"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 6.5H3.75"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2.75V4.25"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3845_27788">
        <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const DoubleCheckIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 5L5.83329 14.1667L1.66663 10"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3334 8.33301L12.0834 14.583L10.8334 13.333"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CopyLinkIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5613_31649)">
      <path
        d="M4 3.30867V2.33301C4 2.06779 4.10536 1.81344 4.29289 1.6259C4.48043 1.43836 4.73478 1.33301 5 1.33301H13.6667C13.9319 1.33301 14.1862 1.43836 14.3738 1.6259C14.5613 1.81344 14.6667 2.06779 14.6667 2.33301V10.9997C14.6667 11.2649 14.5613 11.5192 14.3738 11.7068C14.1862 11.8943 13.9319 11.9997 13.6667 11.9997H12.6723"
        stroke="#DCDCDC"
        strokeWidth="1.33"
      />
      <path
        d="M11.6673 3.33301H2.33398C1.7817 3.33301 1.33398 3.78072 1.33398 4.33301V13.6663C1.33398 14.2186 1.7817 14.6663 2.33398 14.6663H11.6673C12.2196 14.6663 12.6673 14.2186 12.6673 13.6663V4.33301C12.6673 3.78072 12.2196 3.33301 11.6673 3.33301Z"
        stroke="#DCDCDC"
        strokeWidth="1.33"
        strokeLinejoin="round"
      />
      <path
        d="M6.14729 7.7034L7.91129 5.86673C8.39496 5.38306 9.19029 5.3934 9.68729 5.89073C10.1843 6.38773 10.195 7.18306 9.71129 7.66673L9.07463 8.34106M4.48929 9.5824C4.31929 9.7524 3.96763 10.0924 3.96763 10.0924C3.48363 10.5761 3.47029 11.4384 3.96763 11.9357C4.46429 12.4324 5.25963 12.4434 5.74363 11.9594L7.46496 10.3967"
        stroke="#DCDCDC"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.22205 9.44202C6.00062 9.22201 5.86665 8.92907 5.84505 8.61768C5.83228 8.443 5.85722 8.26761 5.91819 8.10341C5.97915 7.93921 6.07471 7.79004 6.19838 7.66602M7.44138 8.61968C7.93838 9.11668 7.94905 9.91202 7.46538 10.396"
        stroke="#DCDCDC"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5613_31649">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ShareIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_165_4671)">
      <path
        d="M9 4.5H4.5C4.10218 4.5 3.72064 4.65804 3.43934 4.93934C3.15804 5.22064 3 5.60218 3 6V13.5C3 13.8978 3.15804 14.2794 3.43934 14.5607C3.72064 14.842 4.10218 15 4.5 15H12C12.3978 15 12.7794 14.842 13.0607 14.5607C13.342 14.2794 13.5 13.8978 13.5 13.5V9"
        stroke="#62AAFF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 9.75L15 3"
        stroke="#62AAFF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 3H15V6.75"
        stroke="#62AAFF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_165_4671">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ImpersonateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-spy"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    strokeWidth="1.4"
    stroke="#62AAFF"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 11h18" />
    <path d="M5 11v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4" />
    <path d="M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M10 17h4" />
  </svg>
);

const AlertIcon = (
  <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <title>alert_fill</title>
      <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="System" transform="translate(-48.000000, -48.000000)" fillRule="nonzero">
          <g id="alert_fill" transform="translate(48.000000, 48.000000)">
            <path
              d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
              id="MingCute"
              fillRule="nonzero"
            />
            <path
              d="M13.299,3.1477 L21.933,18.1022 C22.5103,19.1022 21.7887,20.3522 20.634,20.3522 L3.36601,20.3522 C2.21131,20.3522 1.48962,19.1022 2.06697,18.1022 L10.7009,3.14771 C11.2783,2.14771 12.7217,2.1477 13.299,3.1477 Z M12,15 C11.4477,15 11,15.4477 11,16 C11,16.5523 11.4477,17 12,17 C12.5523,17 13,16.5523 13,16 C13,15.4477 12.5523,15 12,15 Z M12,8 C11.48715,8 11.0644908,8.38604429 11.0067275,8.88337975 L11,9 L11,13 C11,13.5523 11.4477,14 12,14 C12.51285,14 12.9355092,13.613973 12.9932725,13.1166239 L13,13 L13,9 C13,8.44772 12.5523,8 12,8 Z"
              id="形状"
              fill="#ffffff"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const DocumentIcon = (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_595_15072)">
      <path
        d="M3.75 4.25C3.75 3.85218 3.90804 3.47064 4.18934 3.18934C4.47064 2.90804 4.85218 2.75 5.25 2.75H12.75C13.1478 2.75 13.5294 2.90804 13.8107 3.18934C14.092 3.47064 14.25 3.85218 14.25 4.25V14.75C14.25 15.1478 14.092 15.5294 13.8107 15.8107C13.5294 16.092 13.1478 16.25 12.75 16.25H5.25C4.85218 16.25 4.47064 16.092 4.18934 15.8107C3.90804 15.5294 3.75 15.1478 3.75 14.75V4.25Z"
        stroke="#9A9A9A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 5.75H11.25"
        stroke="#9A9A9A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 8.75H11.25"
        stroke="#9A9A9A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 11.75H9.75"
        stroke="#9A9A9A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_595_15072">
        <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const TimeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_744_20097)">
      <path
        d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 8.11358 15.5754 7.23583 15.2362 6.41689C14.897 5.59794 14.3998 4.85382 13.773 4.22703C13.1462 3.60023 12.4021 3.10303 11.5831 2.76381C10.7642 2.42459 9.88642 2.25 9 2.25C8.11358 2.25 7.23583 2.42459 6.41689 2.76381C5.59794 3.10303 4.85382 3.60023 4.22703 4.22703C3.60023 4.85382 3.10303 5.59794 2.76381 6.41689C2.42459 7.23583 2.25 8.11358 2.25 9Z"
        stroke="#9A9A9A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9H11.625"
        stroke="#9A9A9A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 5.25V9"
        stroke="#9A9A9A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_744_20097">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ViewSyncData = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_165_5278)">
      <path
        d="M7.49965 15.5827C6.84685 15.4346 6.21991 15.1897 5.63965 14.856"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 2.41724C11.9911 2.75779 13.3224 3.5945 14.276 4.79039C15.2295 5.98628 15.7488 7.47047 15.7488 8.99999C15.7488 10.5295 15.2295 12.0137 14.276 13.2096C13.3224 14.4055 11.9911 15.2422 10.5 15.5827"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.43392 12.8197C3.0248 12.2253 2.71407 11.5689 2.51367 10.8757"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.34277 7.87489C2.46277 7.16239 2.69377 6.48739 3.01777 5.86864L3.14452 5.63989"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.18066 3.43424C5.8824 2.95116 6.66965 2.60602 7.50041 2.41724"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6.75V11.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 9L9 11.25L6.75 9"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_165_5278">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const ArrowRightIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <g clipPath="url(#clip0_1108_8638)">
      <path
        d="M6.75 5L11.25 9.5L6.75 14"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1108_8638">
        <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const CaretIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <g clipPath="url(#clip0_664_15245)">
      <path
        d="M4.5 7.25L9 11.75L13.5 7.25"
        stroke="#737D9B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_664_15245">
        <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const ArrowCurveIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_554_9925)">
      <path
        d="M9 2.25H12.75V6"
        stroke="#DCDCDC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 2.25L7.098 7.902C6.39515 8.60504 6.00021 9.55839 6 10.5525V15.75"
        stroke="#DCDCDC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_554_9925">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const BellArrowIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_554_9917)">
      <path
        d="M9.375 12.75H3C3.4087 12.5186 3.75736 12.1944 4.01789 11.8036C4.27842 11.4128 4.44356 10.9663 4.5 10.5V8.25C4.54467 7.29831 4.84748 6.3767 5.37596 5.58397C5.90445 4.79125 6.63869 4.15727 7.5 3.75C7.5 3.35218 7.65804 2.97064 7.93934 2.68934C8.22065 2.40804 8.60218 2.25 9 2.25C9.39783 2.25 9.77936 2.40804 10.0607 2.68934C10.342 2.97064 10.5 3.35218 10.5 3.75C11.3613 4.15727 12.0956 4.79125 12.624 5.58397C13.1525 6.3767 13.4553 7.29831 13.5 8.25V9.75"
        stroke="#E96B18"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 12.75V13.5C6.75 14.0967 6.98705 14.669 7.40901 15.091C7.83097 15.5129 8.40326 15.75 9 15.75"
        stroke="#E96B18"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.5L15.75 12.75"
        stroke="#E96B18"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 16.125V12.75H12.375"
        stroke="#E96B18"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_554_9917">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const RefreshAnnotationIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
    <g clipPath="url(#clip0_554_6506)">
      <path
        d="M13.4167 8.16745C13.2536 6.99426 12.7094 5.90722 11.8678 5.07378C11.0261 4.24034 9.93384 3.70673 8.75911 3.55515C7.58439 3.40357 6.39241 3.64244 5.3668 4.23494C4.34119 4.82745 3.53883 5.74074 3.08333 6.83411M2.75 4.16745V6.83411H5.41667"
        stroke="#62AAFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.75 9.50098C2.91304 10.6742 3.45729 11.7612 4.29891 12.5946C5.14053 13.4281 6.23283 13.9617 7.40755 14.1133C8.58228 14.2649 9.77425 14.026 10.7999 13.4335C11.8255 12.841 12.6278 11.9277 13.0833 10.8343M13.4167 13.501V10.8343H10.75"
        stroke="#62AAFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.4165 8.83366C7.4165 9.01047 7.48674 9.18004 7.61177 9.30506C7.73679 9.43009 7.90636 9.50033 8.08317 9.50033C8.25998 9.50033 8.42955 9.43009 8.55458 9.30506C8.6796 9.18004 8.74984 9.01047 8.74984 8.83366C8.74984 8.65685 8.6796 8.48728 8.55458 8.36225C8.42955 8.23723 8.25998 8.16699 8.08317 8.16699C7.90636 8.16699 7.73679 8.23723 7.61177 8.36225C7.48674 8.48728 7.4165 8.65685 7.4165 8.83366Z"
        stroke="#62AAFD"
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_554_6506">
        <rect width="16" height="16" fill="white" transform="translate(0.083252 0.833984)" />
      </clipPath>
    </defs>
  </svg>
);

const IntegrationsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_1268_9144)">
      <path
        d="M2.25 9C2.25 9.59674 2.48705 10.169 2.90901 10.591C3.33097 11.0129 3.90326 11.25 4.5 11.25C5.09674 11.25 5.66903 11.0129 6.09099 10.591C6.51295 10.169 6.75 9.59674 6.75 9C6.75 8.40326 6.51295 7.83097 6.09099 7.40901C5.66903 6.98705 5.09674 6.75 4.5 6.75C3.90326 6.75 3.33097 6.98705 2.90901 7.40901C2.48705 7.83097 2.25 8.40326 2.25 9Z"
        stroke="#DCDCDC"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 4.5C11.25 5.09674 11.4871 5.66903 11.909 6.09099C12.331 6.51295 12.9033 6.75 13.5 6.75C14.0967 6.75 14.669 6.51295 15.091 6.09099C15.5129 5.66903 15.75 5.09674 15.75 4.5C15.75 3.90326 15.5129 3.33097 15.091 2.90901C14.669 2.48705 14.0967 2.25 13.5 2.25C12.9033 2.25 12.331 2.48705 11.909 2.90901C11.4871 3.33097 11.25 3.90326 11.25 4.5Z"
        stroke="#DCDCDC"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 13.5C11.25 14.0967 11.4871 14.669 11.909 15.091C12.331 15.5129 12.9033 15.75 13.5 15.75C14.0967 15.75 14.669 15.5129 15.091 15.091C15.5129 14.669 15.75 14.0967 15.75 13.5C15.75 12.9033 15.5129 12.331 15.091 11.909C14.669 11.4871 14.0967 11.25 13.5 11.25C12.9033 11.25 12.331 11.4871 11.909 11.909C11.4871 12.331 11.25 12.9033 11.25 13.5Z"
        stroke="#DCDCDC"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.52502 8.02501L11.475 5.47501"
        stroke="#DCDCDC"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.52502 9.97501L11.475 12.525"
        stroke="#DCDCDC"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1268_9144">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UserWithPlus = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M10.6668 14V12.6667C10.6668 11.9594 10.3859 11.2811 9.88576 10.7811C9.3857 10.2809 8.70743 10 8.00016 10H4.00016C3.29292 10 2.61464 10.2809 2.11454 10.7811C1.61445 11.2811 1.3335 11.9594 1.3335 12.6667V14"
      stroke="#DCDCDC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.00016 7.33333C7.4729 7.33333 8.66683 6.13943 8.66683 4.66667C8.66683 3.19391 7.4729 2 6.00016 2C4.5274 2 3.3335 3.19391 3.3335 4.66667C3.3335 6.13943 4.5274 7.33333 6.00016 7.33333Z"
      stroke="#DCDCDC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6665 7.33334H10.6665"
      stroke="#DCDCDC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8003 5.33508V9.33508"
      stroke="#DCDCDC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PendingRequestIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.66382 2.66434V5.62884H5.62832"
      stroke="#E96B18"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.69346 8.59336C2.82479 9.78261 3.352 10.8932 4.19041 11.7468C5.02882 12.6004 6.12978 13.1475 7.31648 13.3001C8.50318 13.4528 9.70675 13.2022 10.7339 12.5886C11.7611 11.975 12.5522 11.034 12.9802 9.91669C13.4083 8.7994 13.4484 7.57067 13.0942 6.42783C12.74 5.28499 12.0119 4.29436 11.027 3.61504C10.0421 2.93571 8.85742 2.60711 7.66329 2.68201C6.46915 2.75691 5.33484 3.23096 4.44252 4.02803L2.66382 5.62886"
      stroke="#E96B18"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99976 5.03595V8.00045L10.3714 9.18625"
      stroke="#E96B18"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EyeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      d="M9.50013 3.1665C13.4862 3.1665 16.8468 5.84465 17.8806 9.49973C16.8463 13.1554 13.4859 15.8332 9.50013 15.8332C5.51404 15.8332 2.15347 13.155 1.11963 9.49995C2.15395 5.84427 5.51433 3.1665 9.50013 3.1665ZM9.50013 4.74984C6.51041 4.74984 3.8858 6.60779 2.84557 9.32187L2.77967 9.49904L2.84553 9.67804C3.86009 12.3255 6.38321 14.1587 9.28203 14.2465L9.50013 14.2498C12.4898 14.2498 15.1145 12.3919 16.1547 9.6778L16.2198 9.49904L16.1547 9.32164C15.1402 6.67416 12.6171 4.84099 9.71823 4.75314L9.50013 4.74984ZM9.50013 6.33317C11.249 6.33317 12.6668 7.75094 12.6668 9.49984C12.6668 11.2487 11.249 12.6665 9.50013 12.6665C7.75123 12.6665 6.33346 11.2487 6.33346 9.49984C6.33346 7.75094 7.75123 6.33317 9.50013 6.33317ZM9.50013 7.9165C8.62568 7.9165 7.9168 8.62539 7.9168 9.49984C7.9168 10.3743 8.62568 11.0832 9.50013 11.0832C10.3746 11.0832 11.0835 10.3743 11.0835 9.49984C11.0835 8.62539 10.3746 7.9165 9.50013 7.9165Z"
      fill="#7C87B5"
    />
  </svg>
);

const StrikeEyeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      d="M18.6224 8.95086C17.877 7.38039 16.9899 6.09959 15.9612 5.10845L14.8822 6.18738C15.762 7.02817 16.5284 8.12809 17.1911 9.49796C15.4268 13.1495 12.9224 14.8841 9.49988 14.8841C8.47255 14.8841 7.5263 14.7259 6.66112 14.4095L5.49207 15.5786C6.6937 16.1335 8.02964 16.4109 9.49988 16.4109C13.5755 16.4109 16.6164 14.2883 18.6224 10.0429C18.7031 9.8722 18.7449 9.68572 18.7449 9.4969C18.7449 9.30808 18.7031 9.1216 18.6224 8.95086ZM17.2744 2.15158L16.3704 1.24653C16.3547 1.23076 16.3359 1.21825 16.3154 1.20971C16.2948 1.20117 16.2727 1.19678 16.2504 1.19678C16.2281 1.19678 16.206 1.20117 16.1854 1.20971C16.1648 1.21825 16.1461 1.23076 16.1304 1.24653L13.8111 3.5647C12.5325 2.91158 11.0954 2.58501 9.49988 2.58501C5.42421 2.58501 2.38336 4.70767 0.377334 8.95298C0.296701 9.12372 0.254883 9.3102 0.254883 9.49902C0.254883 9.68784 0.296701 9.87432 0.377334 10.0451C1.17875 11.733 2.1436 13.086 3.27187 14.104L1.02791 16.3473C0.996124 16.3791 0.978266 16.4222 0.978266 16.4672C0.978266 16.5122 0.996124 16.5553 1.02791 16.5871L1.93317 17.4924C1.96498 17.5242 2.00811 17.542 2.05309 17.542C2.09806 17.542 2.14119 17.5242 2.173 17.4924L17.2744 2.39162C17.2902 2.37587 17.3027 2.35716 17.3112 2.33656C17.3198 2.31597 17.3242 2.29389 17.3242 2.2716C17.3242 2.2493 17.3198 2.22723 17.3112 2.20664C17.3027 2.18604 17.2902 2.16733 17.2744 2.15158ZM1.8087 9.49796C3.5751 5.8464 6.07945 4.1118 9.49988 4.1118C10.6564 4.1118 11.708 4.31028 12.662 4.71382L11.1713 6.20456C10.4653 5.82787 9.65692 5.68807 8.86542 5.80578C8.07393 5.92349 7.34122 6.29247 6.7754 6.8583C6.20957 7.42413 5.84059 8.15683 5.72288 8.94833C5.60517 9.73982 5.74497 10.5482 6.12165 11.2542L4.3527 13.0231C3.37365 12.159 2.52968 10.9883 1.8087 9.49796ZM7.04006 9.49796C7.04043 9.12403 7.129 8.75547 7.29857 8.42221C7.46815 8.08894 7.71394 7.80038 8.01599 7.57996C8.31804 7.35953 8.66783 7.21347 9.03694 7.15363C9.40604 7.09379 9.78406 7.12186 10.1403 7.23556L7.15266 10.2232C7.07777 9.98874 7.03979 9.74408 7.04006 9.49796Z"
      fill="#7C87B5"
    />
    <path
      d="M9.41555 11.8765C9.34218 11.8765 9.26987 11.8731 9.19819 11.8665L8.07812 12.9866C8.7518 13.2446 9.48578 13.3019 10.1913 13.1517C10.8969 13.0014 11.5438 12.65 12.0539 12.1399C12.564 11.6298 12.9155 10.9828 13.0657 10.2773C13.216 9.57172 13.1586 8.83774 12.9006 8.16406L11.7806 9.28413C11.7872 9.3558 11.7905 9.42811 11.7905 9.50148C11.7907 9.81342 11.7294 10.1223 11.6101 10.4106C11.4908 10.6988 11.3159 10.9607 11.0953 11.1812C10.8747 11.4018 10.6128 11.5767 10.3246 11.696C10.0364 11.8153 9.72748 11.8767 9.41555 11.8765Z"
      fill="#7C87B5"
    />
  </svg>
);

const NewIntegrationsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <g clipPath="url(#clip0_3035_11661)">
      <path
        d="M18.3333 9.16675H3.66663L8.70829 3.66675"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66663 12.8333H18.3333L13.2916 18.3333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3035_11661">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const PlyableLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M25.3334 13.3337H6.66675V10.667H25.3334V13.3337ZM25.3334 21.3337H6.66675V18.667H25.3334V21.3337Z"
      fill="white"
    />
  </svg>
);

const ArrowUpIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20 16L12 8L4 16"
      stroke="#737D9B"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReferenceIntegrationsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <g clipPath="url(#clip0_3253_19169)">
      <path
        d="M18.3337 9.1665H3.66699L8.70866 3.6665"
        stroke="#737D9B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66699 12.8335H18.3337L13.292 18.3335"
        stroke="#737D9B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3253_19169">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const DownloadPlayableIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M4.00034 14.8993C3.25738 14.1402 2.69691 13.222 2.36137 12.2142C2.02584 11.2064 1.92405 10.1355 2.0637 9.08256C2.20335 8.02962 2.5808 7.02226 3.16743 6.1368C3.75407 5.25133 4.53452 4.51098 5.44967 3.97182C6.36482 3.43265 7.39067 3.10882 8.44951 3.02484C9.50835 2.94087 10.5724 3.09895 11.5611 3.48712C12.5498 3.8753 13.4372 4.48337 14.1561 5.2653C14.8749 6.04723 15.4065 6.9825 15.7103 8.00026H17.5003C18.4659 8.00015 19.4058 8.31059 20.1813 8.8857C20.9569 9.46082 21.5269 10.2701 21.8071 11.1941C22.0874 12.118 22.063 13.1076 21.7377 14.0166C21.4123 14.9257 20.8032 15.706 20.0003 16.2423"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 21L12 12"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 17L12 21L16 17"
      stroke="#737D9B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Threads3dIcon = (
  <svg
    width="144"
    height="154"
    viewBox="0 0 144 154"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="9.37466" y1="40.5999" x2="72.3747" y2="74.5999" stroke="white" strokeWidth="10" />
    <line x1="133.375" y1="41.4001" x2="70.3747" y2="75.4001" stroke="white" strokeWidth="10" />
    <line x1="72" y1="76" x2="72" y2="146" stroke="white" strokeWidth="10" />
    <path
      d="M69 6.73205C70.8564 5.66026 73.1436 5.66025 75 6.73205L131.354 39.2679C133.21 40.3397 134.354 42.3205 134.354 44.4641V109.536C134.354 111.679 133.21 113.66 131.354 114.732L75 147.268C73.1436 148.34 70.8564 148.34 69 147.268L12.6462 114.732C10.7898 113.66 9.64617 111.679 9.64617 109.536V44.4641C9.64617 42.3205 10.7898 40.3397 12.6462 39.2679L69 6.73205Z"
      stroke="white"
      strokeWidth="10"
    />
  </svg>
);

export const icons = {
  CheckIcon,
  BellIcon,
  SettingsIcon,
  SearchIcon,
  PlusIcon,
  UploadIcon,
  AppImgIcon,
  SortingChevronIcon,
  ChevronDownIcon,
  MicIcon,
  AttachIcon,
  SmilePlusIcon,
  FlagIcon,
  DotsIcon,
  PencilIcon,
  BinIcon,
  MailIcon,
  ReferenceDocumentIcon,
  ReferenceImageIcon,
  ReferenceLinkIcon,
  ReferenceGoogleDriveLinkIcon,
  ReferenceSlackLinkIcon,
  CalendarIcon,
  UserIcon,
  ExternalLinkIcon,
  DownloadIcon,
  RadioButtonChevron,
  LinkIcon,
  CloseIcon,
  UploadCloudIcon,
  SendIcon,
  InfoIcon,
  LikeIcon,
  LikeFilledIcon,
  BranchIcon,
  ReplyIcon,
  AddUserIcon,
  RemoveUserIcon,
  QuestionEventIcon,
  InsightEventIcon,
  DecisionEventIcon,
  ActionEventIcon,
  ResolutionEventIcon,
  EndEventIcon,
  StoppedEventIcon,
  FilterIcon,
  ExitIcon,
  IssueEventIcon,
  CheckCircle,
  BrokenLink,
  DoubleCheckIcon,
  ShareIcon,
  ImpersonateIcon,
  AlertIcon,
  CopyLinkIcon,
  DocumentIcon,
  ViewSyncData,
  ArrowRightIcon,
  TimeIcon,
  CaretIcon,
  ArrowCurveIcon,
  BellArrowIcon,
  RefreshAnnotationIcon,
  IntegrationsIcon,
  UserWithPlus,
  PendingRequestIcon,
  EyeIcon,
  StrikeEyeIcon,
  NewIntegrationsIcon,
  PlyableLogo,
  ArrowUpIcon,
  ReferenceIntegrationsIcon,
  DownloadPlayableIcon,
  Threads3dIcon,
};
